// Evolution Bikes search map (2026-10-19, data/search-audit/2026-10-19/REPORT.md).
// Fixes wrong site-search matches in every language, on top of Shopify search:
// - R: broad category and brand queries go straight to the right collection (any language).
// - W: queries rewritten to words that find the right products (typos, slang, missing translations).
// - N: brands or models we do not sell: go to the closest collection with a short note.
// Collection URLs and titles come from snippets/search-map.liquid (localized, current market).
(() => {
  if (window.EvoSearchMap) return;

  const R = {
    "biciclette-da-corsa": ["bici da corsa", "bici corsa", "bici strada", "bici da strada", "bdc", "bici da coraa", "bicicletta da corsa", "biciclette da corsa",
      "road bike", "road bikes", "rennrad", "rennrader", "velo de route", "velos de route", "bicicleta de carretera", "bicicletas de carretera", "rower szosowy", "rowery szosowe"],
    "biciclette-gravel": ["bici gravel", "bici da gravel", "biciclette gravel", "gravel bike", "gravel bikes", "gravelbike", "velo gravel", "bicicleta gravel", "rower gravel", "rower gravelowy"],
    "biciclette-mtb": ["mtb", "mountain bike", "bici mtb", "biciclette mtb", "bicicletta mtb", "biciclette bmt", "myb", "mtb donna bici", "mountain bike donna",
      "mountainbike", "vtt", "bicicleta de montana", "bicicleta mtb", "rower gorski", "rower mtb"],
    "ebikes-bici-elettriche": ["bici elettrica", "bici elettriche", "bicicletta elettrica", "biciclette elettriche", "ebike", "e bike", "ebikes", "e bikes", "ebaik",
      "electric bike", "electric bikes", "elektrofahrrad", "velo electrique", "bicicleta electrica", "rower elektryczny"],
    "mtbelettriche": ["emtb", "e mtb", "ebike mtb", "e bike mtb", "mtb elettrica", "mtb elettriche", "e mountain bike", "e mtb fully"],
    "biciclette-da-citta": ["bici da citta", "bici citta", "city bike", "citybike", "velo de ville", "bicicleta urbana", "rower miejski"],
    "biciclette-bambino": ["bici bambino", "bici bimbo", "bici per bambini", "kids bike", "kinderfahrrad", "velo enfant", "bicicleta infantil", "rower dzieciecy"],
    "caschi-bici": ["casco", "caschi", "casco bici", "caschi bici", "helmet", "bike helmet", "helmets", "fahrradhelm", "casque velo", "casque", "kask rowerowy", "kask"],
    "caschi-mountain-bike": ["casco mtb", "caschi mtb", "mtb helmet", "mtb helm", "casque vtt", "kask mtb"],
    "scarpe-mtb": ["scarpe mtb", "mtb shoes", "mtb schuhe", "chaussures vtt", "zapatillas mtb", "buty mtb"],
    "scarpe-bici-da-corsa": ["scarpe bici da corsa", "scarpe da corsa", "road shoes", "rennradschuhe", "chaussures route", "zapatillas carretera", "buty szosowe"],
    "guanti": ["guanti", "guanti ciclismo", "gloves", "handschuhe", "gants", "guantes", "rekawiczki"],
    "selle": ["sella", "selle", "sella bici", "saddle", "saddles", "sattel", "sillin", "siodelko"],
    "pedali": ["pedali", "pedals", "pedale", "pedales", "pedaly"],
    "copertoni": ["copertoni", "copertone", "copertoncino", "copertoncini", "tyres", "tires", "reifen", "pneus", "cubiertas", "opony"],
    "copertoni-bici-da-corsa": ["copertoni bici da corsa", "copertoni corsa", "copertoni da corsa"],
    "copertoni-gravel": ["copertoni gravel", "copertone gravel"],
    "pneumatici-per-mtb": ["copertoni mtb", "copertone mtb", "gomme mtb", "pneumatici mtb", "mtb tyres", "mtb tires"],
    "camere-d-aria": ["camera d aria", "camere d aria", "camera daria", "camere daria", "inner tube", "inner tubes", "schlauch", "chambre a air", "camara", "detka"],
    "catene": ["catena", "catene", "chain", "kette", "chaine", "cadena", "lancuch"],
    "cassette": ["cassetta", "pacco pignoni", "cassette", "kassette", "kaseta"],
    "ciclo-computer": ["ciclocomputer", "ciclo computer", "contachilometri", "contachilometro", "bike computer", "fahrradcomputer", "compteur velo", "ciclocomputador", "licznik rowerowy"],
    "illuminazione": ["luci", "luci bici", "bike lights", "fahrradlicht", "eclairage velo", "luces bici", "oswietlenie rowerowe"],
    "rulli": ["rullo", "rulli", "rullo bici", "turbo trainer", "rollentrainer", "home trainer", "rodillo", "trenazer"],
    "borracce": ["borraccia", "borracce", "water bottle", "trinkflasche", "bidon"],
    "portaborraccia": ["portaborraccia", "porta borraccia", "portaborracce", "bottle cage", "flaschenhalter", "porte bidon", "portabidon", "koszyk na bidon"],
    "pompe-e-riparazione": ["pompa", "pompe", "pompa bici", "bike pump", "luftpumpe", "pompe velo", "bomba bici", "pompka rowerowa"],
    "multiattrezzi": ["multitool", "multiattrezzo", "multiattrezzi", "multi outil", "multiherramienta"],
    "cavalletti-manutenzione": ["cavalletto manutenzione", "bike stand", "montagestander", "pied d atelier", "soporte taller", "stojak serwisowy"],
    "occhiali": ["occhiali", "occhiali ciclismo", "sunglasses", "fahrradbrille", "lunettes velo", "gafas ciclismo", "okulary rowerowe"],
    "salopette-e-pantaloni": ["salopette", "bib shorts", "radhose", "fahrradhose", "cuissard", "culotte", "spodenki"],
    "maglie": ["maglia", "maglie", "maglia ciclismo", "jersey", "trikot", "maillot", "koszulka kolarska"],
    "copriscarpe": ["copriscarpe", "overshoes", "uberschuhe", "couvre chaussures", "cubrezapatillas", "ochraniacze na buty"],
    "freni-a-disco": ["freno a disco", "freni a disco", "disc brake", "disc brakes", "scheibenbremse", "frein a disque", "freno de disco", "hamulec tarczowy"],
    "zaini": ["zaino", "zaini"],
    "erogatori-e-cartucce-co2": ["co2", "bomboletta co2", "cartucce co2"],
    "valvole-tubeless": ["valvole tubeless", "valvola tubeless"],
    "bici-da-corsa-usate": ["bici da corsa usata", "bici da corsa usate"],
    "usato": ["bici usate", "bici usata", "usato", "usate"],
    "hot-promo": ["offerte", "promo", "saldi", "codice sconto", "sconti", "sale"],
    "trek": ["trek", "treck", "bici trek"], "scott": ["scott", "bici scott"], "pissei": ["pissei"], "megamo": ["megamo"], "garmin": ["garmin"],
    "castelli": ["castelli"], "colnago": ["colnago", "bici colnago"], "wilier": ["wilier", "willier", "bici wilier"], "sram": ["sram"],
    "berria": ["berria"], "rali": ["rali"], "bottecchia": ["bottecchia"], "fantic": ["fantic"], "via-veneto": ["via veneto"], "raymon": ["raymon"],
    "focus": ["focus"], "merida": ["merida"], "lapierre": ["lapierre"], "selle-italia": ["selle italia"], "oakley": ["oakley"],
    "vittoria": ["vittoria"], "pirelli": ["pirelli"],
  };
  const W = {
    "specilized": "specialized", "specialised": "specialized",
    "tesasraggi": "tensaraggi", "tiraraggi": "tensaraggi",
    "700x28": "copertone 700x28", "700x25": "copertone 700x25", "700x32": "copertone 700x32",
    "scott mtb": "scott mountain bike", "mtb scott": "scott mountain bike", "scale": "scott scale",
    "coppi": "bici coppi", "trekking": "bici trekking", "pieghevole": "bici pieghevole",
    "cargo": "bici cargo", "body": "body ciclismo", "manopole sp": "manopole spugna",
    "genix 9 pro inreach": "garmin fenix", "garnin": "garmin", "garnin tcr": "garmin",
  };
  const N = {
    "cube": ["Cube", "biciclette-e-telai"], "orbea": ["Orbea", "biciclette-e-telai"], "canyon": ["Canyon", "biciclette-e-telai"],
    "giant": ["Giant", "biciclette-e-telai"], "bianchi": ["Bianchi", "biciclette-e-telai"], "bici bianchi": ["Bianchi", "biciclette-e-telai"],
    "steppenwolf": ["Steppenwolf", "biciclette-e-telai"], "topstone": ["Cannondale Topstone", "biciclette-gravel"],
    "poc": ["POC", "caschi-bici"], "fujita": ["Fujita", "biciclette-e-telai"], "fujta": ["Fujita", "biciclette-e-telai"],
  };

  const norm = (s) => String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "")
    .replace(/ł/g, "l").replace(/[^a-z0-9]+/g, " ").trim();
  const redirects = new Map();
  for (const [handle, terms] of Object.entries(R)) for (const t of terms) redirects.set(norm(t), handle);
  const rewrites = new Map(Object.entries(W).map(([k, v]) => [norm(k), v]));
  const missing = new Map(Object.entries(N).map(([k, v]) => [norm(k), v]));

  const data = () => window.EvoSearchMapData || { root: "/", collections: {}, i18n: {} };
  const collection = (handle) => {
    const c = data().collections[handle];
    return c || { url: `${data().root}collections/${handle}`, title: handle.replace(/-/g, " ") };
  };

  // { type: "redirect"|"rewrite"|"missing", url?, q?, label?, handle? } or null
  const lookup = (query) => {
    const key = norm(query);
    if (!key) return null;
    if (missing.has(key)) {
      const [label, handle] = missing.get(key);
      return { type: "missing", label, handle, url: collection(handle).url };
    }
    if (redirects.has(key)) {
      const handle = redirects.get(key);
      return { type: "redirect", handle, url: collection(handle).url };
    }
    if (rewrites.has(key)) return { type: "rewrite", q: rewrites.get(key) };
    return null;
  };

  const withParam = (url, key, value) => {
    const u = new URL(url, location.origin);
    u.searchParams.set(key, value);
    return u.pathname + u.search;
  };
  const target = (hit, form) => {
    if (hit.type === "rewrite") {
      const u = new URL(form ? form.action : location.href, location.origin);
      const params = form ? new URLSearchParams(new FormData(form)) : new URLSearchParams(location.search);
      params.set("q", hit.q);
      params.set("sm", "1");
      return `${u.pathname}?${params}`;
    }
    if (hit.type === "missing") return withParam(hit.url, "nf", hit.label);
    return hit.url;
  };

  // Brands without a map entry (2026-10-22): if the query is a brand that has its own collection, e.g. "mahle" ->
  // /collections/mahle, and that collection's products carry the brand as vendor, open the collection. New brands
  // work without editing the map. One small request, cached for the visit; any failure falls back to normal search.
  const brandCache = {};
  const brandHit = (query) => {
    const key = norm(query);
    if (!key || key.length < 3 || key.split(" ").length > 3 || /^\d+$/.test(key)) return Promise.resolve(null);
    if (key in brandCache) return Promise.resolve(brandCache[key]);
    let stored = null;
    try { stored = sessionStorage.getItem(`evo-brand-${key}`); } catch (e) {}
    if (stored !== null) return Promise.resolve(brandCache[key] = stored ? JSON.parse(stored) : null);
    const handle = key.replace(/ /g, "-");
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), 2500);
    return fetch(`${data().root}collections/${handle}/products.json?limit=5`, { signal: ctrl.signal })
      .then((r) => (r.ok ? r.json() : { products: [] }))
      .then((j) => {
        const products = j.products || [];
        const ok = products.length && products.some((p) => norm(p.vendor) === key);
        return ok ? { type: "redirect", handle, url: (data().collections[handle] || {}).url || `${data().root}collections/${handle}` } : null;
      })
      .catch(() => null)
      .then((hit) => {
        clearTimeout(timer);
        brandCache[key] = hit;
        try { sessionStorage.setItem(`evo-brand-${key}`, hit ? JSON.stringify(hit) : ""); } catch (e) {}
        return hit;
      });
  };
  const searchUrl = (form) => `${new URL(form.action, location.origin).pathname}?${new URLSearchParams(new FormData(form))}`;

  // Search forms (header and search page): Enter or the search button.
  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !/\/search\/?$/.test(new URL(form.action, location.origin).pathname)) return;
    if (form.querySelector('[aria-selected="true"] a')) return; // a suggestion is selected: let it open
    if (form.dataset.evoBrandChecked) return; // second pass after the brand check: normal search
    const q = form.querySelector('input[name="q"]')?.value;
    const hit = lookup(q);
    event.preventDefault();
    event.stopImmediatePropagation();
    if (hit) { location.assign(target(hit, form)); return; }
    brandHit(q).then((brand) => { location.assign(brand ? brand.url : searchUrl(form)); });
  }, true);

  // Direct visits to /search?q=... (links, bookmarks, Google).
  const params = new URLSearchParams(location.search);
  if (/\/search\/?$/.test(location.pathname) && params.get("q") && !params.get("sm")) {
    const hit = lookup(params.get("q"));
    if (hit) location.replace(target(hit, null));
    else brandHit(params.get("q")).then((brand) => { if (brand) location.replace(brand.url); });
  }

  // Note on the landing page after a brand we do not sell.
  const showNote = () => {
    const label = params.get("nf");
    if (!label || document.querySelector(".search-map-note")) return;
    const text = (data().i18n.notStocked || "{{ brand }}").replace("{{ brand }}", label.slice(0, 60));
    const note = document.createElement("p");
    note.className = "search-map-note container";
    note.setAttribute("role", "status");
    note.textContent = text;
    (document.querySelector("#MainContent") || document.body).prepend(note);
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", showNote);
  else showNote();

  // Predictive search: query to send, and a first row linking to the right collection.
  // Rewrites send the better words; redirects send the collection title in the page language, so the
  // product suggestions under the first row match the collection (e.g. "mtb" -> "Biciclette MTB").
  const predictiveQuery = (query) => {
    const hit = lookup(query);
    if (!hit) return query;
    if (hit.type === "rewrite") return hit.q;
    const c = data().collections[hit.handle];
    return c ? c.title : query;
  };
  const decoratePredictive = (container, query) => {
    const hit = lookup(query);
    if (!hit || hit.type === "rewrite") return;
    const list = container.querySelector("#predictive-search-results, .predictive-search-results, [data-predictive-search]") || container;
    if (list.querySelector(".search-map-pin")) return;
    const c = collection(hit.handle);
    // The theme may already list this collection: no second link.
    if (hit.type === "redirect" && list.querySelector(`a[href*="/collections/${hit.handle}"]`)) return;
    const link = document.createElement("a");
    link.className = "search-map-pin";
    link.href = hit.type === "missing" ? withParam(c.url, "nf", hit.label) : c.url;
    const i18n = data().i18n;
    link.textContent = hit.type === "missing"
      ? (i18n.notStocked || "{{ brand }}").replace("{{ brand }}", hit.label)
      : (i18n.goTo || "{{ title }}").replace("{{ title }}", c.title);
    list.prepend(link);
  };

  window.EvoSearchMap = { lookup, predictiveQuery, decoratePredictive, norm };
})();
